import { ContraLogoSuspenseLoaderIcon } from '#app/__generated__/components/Icons/ContraLogoSuspenseLoader.js';
import { css, keyframes, styled } from 'styled-components';

const AppLoaderPage = styled.div`
  ${({ theme }) => css`
    height: 100vh;
    position: relative;
    background-color: ${theme.colorsV2.gray05};
    padding: 0 32px;
  `}
`;

const pulseKeyframes = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const PulsingContraLogoSuspenseLogo = styled(ContraLogoSuspenseLoaderIcon)`
  animation: ${pulseKeyframes} 1.5s ease-in infinite;
`;

const AbsolutelyPositioned = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  justify-content: center;
  height: 100%;
`;

export const AppLoader = () => {
  return (
    <AppLoaderPage>
      <AbsolutelyPositioned>
        <PulsingContraLogoSuspenseLogo size={60} />
      </AbsolutelyPositioned>
    </AppLoaderPage>
  );
};
